import { LitElement, html, property } from 'lit-element'
import { nothing } from 'lit-html'
import anchorButtonStyles from './anchor-button.styles.scss'
import { unsafeSVG } from 'lit-html/directives/unsafe-svg'
// for some unknown reasons this fails on the CI but not locally
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { NavigationLinkTarget } from '../../common/global-props'
import { ifDefined } from 'lit-html/directives/if-defined'

export enum AnchorButtonVariant {
  primary = 'primary',
  secondary = 'secondary',
  tertiary = 'tertiary',
}

/**
 * Note: This is a temporary solution for EAP and will be removed
 * once Chameleon has their own AnchorButton.
 */
export class GoToAnchorButton extends LitElement {
  static readonly tagName = 'goto-anchor-button'

  @property({ type: String })
  href = ''
  @property()
  icon = ''
  @property({ type: String })
  target: NavigationLinkTarget | undefined
  @property({ type: String })
  text = ''
  @property({ type: String })
  variant: AnchorButtonVariant | undefined

  static get styles() {
    return anchorButtonStyles
  }

  render() {
    const iconElement = this.icon ? html`<chameleon-svg slot="end">${unsafeSVG(this.icon)}</chameleon-svg>` : nothing
    return html`
      <a
        href="${this.href}"
        class="${ifDefined(this.variant)}"
        target="${ifDefined(this.target ?? '_self')}"
        rel="noreferrer"
      >
        ${this.text} ${iconElement}
      </a>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    readonly [GoToAnchorButton.tagName]: GoToAnchorButton
  }
}
